<template>
  <fragment>
    <AppBody
      title="Relatórios Analíticos"
      subtitle="Consumidores ElevenTickets"
      disableDivider
    >
      <CardModule untitle>
        <v-form
          @submit.prevent="$relatorios_analiticos.filtroConsumidoresOmni()"
          class="search-forms"
        >
          <v-row v-if="isAdmin">
            <v-col cols="12" md="3" sm="4">
              <BaseTextField
                label="Consumidor"
                placeholder="Insira o nome"
                v-model="
                  $relatorios_analiticos.filterConsumidoresOmni.nomeConsumidor
                "
                type="text"
                @click:clear="
                  $relatorios_analiticos.clearfilterConsumidoresOmniFields(
                    'nomeConsumidor'
                  )
                "
                hide-details
              ></BaseTextField>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseAutocomplete
                label="Estado"
                item-text="dsc_lang"
                return-object
                placeholder="Selecione o estado"
                autocomplete="null"
                clearable
                auto-select-first
                :loading="$config.loading_estados"
                :items="$config.estados.result"
                v-model="estado"
                @click:clear="
                  $relatorios_analiticos.clearfilterConsumidoresOmniFields(
                    'estado'
                  )
                "
              >
              </BaseAutocomplete>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseAutocomplete
                label="Cidade"
                item-text="dsc_lang"
                item-value="dsc_lang"
                clearable
                placeholder="Selecione a cidade"
                :loading="$config.loading_cidades"
                :items="$config.cidades.result"
                v-model="$relatorios_analiticos.filterConsumidoresOmni.cidade"
                @click:clear="
                  $relatorios_analiticos.clearfilterConsumidoresOmniFields(
                    'cidade'
                  )
                "
              >
              </BaseAutocomplete>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseSelect
                label="Intervalo de Datas"
                :items="$relatorios_analiticos.intervalo_data"
                item-text="text"
                item-value="value"
                v-model="
                  $relatorios_analiticos.filterConsumidoresOmni.intervalo_datas
                "
                placeholder="Selecione o intervalo de datas"
                @click:clear="
                  $relatorios_analiticos.clearfilterConsumidoresOmniFields(
                    'intervalo_data'
                  )
                "
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
              sm="4"
              v-if="
                $relatorios_analiticos.filterConsumidoresOmni.intervalo_datas !=
                'custom'
              "
            >
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <BaseTextField
                    label="Data Nascimento"
                    v-model="dateRangeText"
                    :append-icon="$config.icons.calendar"
                    readonly
                    :disabled="
                      $relatorios_analiticos.filterConsumidoresOmni
                        .intervalo_datas != null
                        ? false
                        : true
                    "
                    v-bind="attrs"
                    v-on="on"
                    :placeholder="placeholderData"
                    :color="$config.dados.corinputs"
                    clearable
                    :error-messages="
                      $relatorios_analiticos.filterConsumidoresOmni.error
                        .range_dates
                    "
                    @input="
                      $relatorios_analiticos.filterConsumidoresOmni.error.range_dates =
                        []
                    "
                    @click:clear="
                      $relatorios_analiticos.clearfilterConsumidoresOmniFields(
                        'dates'
                      )
                    "
                  ></BaseTextField>
                </template>
                <v-date-picker
                  v-model="computeRange"
                  :active-picker.sync="activePicker"
                  @change="computeRange"
                  locale="pt"
                  @input="menu = false"
                  :header-color="$config.dados.corinputs"
                  :color="$config.dados.corinputs"
                  range
                  @click:month="monthEvent"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col v-else>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <BaseTextField
                    label="Datas"
                    v-model="dateRangeText"
                    :append-icon="$config.icons.calendar"
                    readonly
                    :disabled="
                      $relatorios_analiticos.filterConsumidoresOmni
                        .intervalo_datas != null
                        ? false
                        : true
                    "
                    v-bind="attrs"
                    v-on="on"
                    :error-messages="
                      $relatorios_analiticos.filterConsumidoresOmni.error
                        .range_dates
                    "
                    @input="
                      $relatorios_analiticos.filterConsumidoresOmni.error.range_dates =
                        []
                    "
                    :placeholder="placeholderData"
                    :color="$config.dados.corinputs"
                    clearable
                    @click:clear="
                      $relatorios_analiticos.clearfilterConsumidoresOmniFields(
                        'dates'
                      )
                    "
                  ></BaseTextField>
                </template>
                <v-date-picker
                  v-model="
                    $relatorios_analiticos.filterConsumidoresOmni.range_dates
                  "
                  :active-picker.sync="activePicker"
                  locale="pt"
                  @input="
                    $relatorios_analiticos.filterConsumidoresOmni.range_dates
                      .length == 2
                      ? (menu = false)
                      : (menu = true)
                  "
                  :header-color="$config.dados.corinputs"
                  :color="$config.dados.corinputs"
                  range
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseSelect
                label="Promoções e campanhas"
                :items="$relatorios_analiticos.promocoes"
                item-text="text"
                item-value="value"
                clearable
                v-model="
                  $relatorios_analiticos.filterConsumidoresOmni.promocoes
                "
                @click:clear="
                  $relatorios_analiticos.clearfilterConsumidoresOmniFields(
                    'promocoes'
                  )
                "
              />
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseSelect
                label="Intervalo de Datas Criação"
                :items="$relatorios_analiticos.intervalo_data"
                item-text="text"
                item-value="value"
                v-model="
                  $relatorios_analiticos.filterConsumidoresOmni
                    .intervalo_datas_criacao
                "
                placeholder="Selecione o intervalo de datas"
                @click:clear="
                  $relatorios_analiticos.clearfilterConsumidoresOmniFields(
                    'intervalo_datas_criacao'
                  )
                "
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
              sm="4"
              v-if="
                $relatorios_analiticos.filterConsumidoresOmni
                  .intervalo_datas_criacao != 'custom'
              "
            >
              <v-menu
                ref="menuCreate"
                v-model="menuCreate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <BaseTextField
                    label="Data Criação"
                    v-model="dateRangeTextCreate"
                    :append-icon="$config.icons.calendar"
                    readonly
                    :disabled="
                      $relatorios_analiticos.filterConsumidoresOmni
                        .intervalo_datas_criacao != null
                        ? false
                        : true
                    "
                    v-bind="attrs"
                    v-on="on"
                    :placeholder="placeholderData"
                    :color="$config.dados.corinputs"
                    clearable
                    :error-messages="
                      $relatorios_analiticos.filterConsumidoresOmni.error
                        .range_dates_create
                    "
                    @input="
                      $relatorios_analiticos.filterConsumidoresOmni.error.range_dates_create =
                        []
                    "
                    @click:clear="
                      $relatorios_analiticos.clearfilterConsumidoresOmniFields(
                        'dates'
                      )
                    "
                  ></BaseTextField>
                </template>
                <v-date-picker
                  v-model="computeRangeCreate"
                  :active-picker.sync="activePicker"
                  @change="computeRangeCreate"
                  locale="pt"
                  @input="menuCreate = false"
                  :header-color="$config.dados.corinputs"
                  :color="$config.dados.corinputs"
                  range
                  @click:month="monthCreateEvent"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col v-else cols="12" md="3" sm="4">
              <v-menu
                ref="menuCreate"
                v-model="menuCreate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <BaseTextField
                    label="Datas"
                    v-model="dateRangeTextCreate"
                    :append-icon="$config.icons.calendar"
                    readonly
                    :disabled="
                      $relatorios_analiticos.filterConsumidoresOmni
                        .intervalo_datas_criacao != null
                        ? false
                        : true
                    "
                    v-bind="attrs"
                    v-on="on"
                    :error-messages="
                      $relatorios_analiticos.filterConsumidoresOmni.error
                        .range_dates_create
                    "
                    @input="
                      $relatorios_analiticos.filterConsumidoresOmni.error.range_dates_create =
                        []
                    "
                    :placeholder="placeholderData"
                    :color="$config.dados.corinputs"
                    clearable
                    @click:clear="
                      $relatorios_analiticos.clearfilterConsumidoresOmniFields(
                        'dates'
                      )
                    "
                  ></BaseTextField>
                </template>
                <v-date-picker
                  v-model="
                    $relatorios_analiticos.filterConsumidoresOmni
                      .range_dates_create
                  "
                  :active-picker.sync="activePicker"
                  locale="pt"
                  @input="
                    $relatorios_analiticos.filterConsumidoresOmni
                      .range_dates_create.length == 2
                      ? (menuCreate = false)
                      : (menuCreate = true)
                  "
                  :header-color="$config.dados.corinputs"
                  :color="$config.dados.corinputs"
                  range
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="d-flex justify-end">
              <BaseButton
                tabindex="13"
                variant="filter"
                data-cy="filtrar"
                class="button rounded-xxl"
                type="submit"
                :loading="
                  $relatorios_analiticos.loading_relatorio_consumidores_omni
                "
              >
                Gerar e Enviar por E-mail
              </BaseButton>
            </v-col>
          </v-row>
        </v-form>
      </CardModule>
    </AppBody>
  </fragment>
</template>
<script>
import dayjs from "dayjs";
import CardModule from "@/components/cards/CardModule.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
import BaseButton from "@/components/forms/BaseButton.vue";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import AppBody from "@/layouts/components/AppBody.vue";
export default {
  name: "ConsumerAnalytical",
  metaInfo: {
    title: "Relatório Analítico de Consumidores ElevenTickets | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content:
          "Relatório Analítico de Consumidores ElevenTickets | ElevenTickets",
      },
    ],
  },
  props: {},
  components: {
    CardModule,
    BaseSelect,
    BaseTextField,
    BaseAutocomplete,
    BaseButton,
    AppBody,
  },
  data() {
    return {
      dayjs: dayjs,
      placeholderData: "dd/mm/aa ~ dd/mm/aa",
      disableRegionais: false,
      menu: false,
      menu3: false,
      activePicker: null,
      activePicker3: null,
      estado: null,
      cidades: [],
    };
  },
  watch: {
    "$relatorios_analiticos.filterConsumidoresOmni.intervalo_datas"(e) {
      switch (e) {
        case "date": {
          const currentDay = new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
          // const day = new Date(new Date(currentDay).setDate(new Date(currentDay).getDate() + 1)).toISOString().slice(0, 10);
          this.$relatorios_analiticos.filterConsumidoresOmni.range_dates = [
            currentDay,
            currentDay,
          ];
          break;
        }
        case "week": {
          const currentDayWeek = this.dayjs().day(0).format("YYYY-MM-DD");
          const week = this.dayjs().day(6).format("YYYY-MM-DD");
          this.$relatorios_analiticos.filterConsumidoresOmni.range_dates = [
            currentDayWeek,
            week,
          ];
          break;
        }
        case "month": {
          const currentDayMonth = this.dayjs()
            .startOf("month")
            .format("YYYY-MM-DD");
          const month = this.dayjs().endOf("month").format("YYYY-MM-DD");
          this.$relatorios_analiticos.filterConsumidoresOmni.range_dates = [
            currentDayMonth,
            month,
          ];
          break;
        }
        case "custom": {
          const currentDayCustom = new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
          const custom = new Date(
            new Date(currentDayCustom).setDate(
              new Date(currentDayCustom).getDate() + 1
            )
          )
            .toISOString()
            .slice(0, 10);
          this.$relatorios_analiticos.filterConsumidoresOmni.range_dates = [
            currentDayCustom,
            custom,
          ];
          break;
        }
        default: {
          const defaultDay = new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
          const defaultDayCustom = new Date(
            new Date(defaultDay).setDate(new Date(defaultDay).getDate() + 1)
          )
            .toISOString()
            .slice(0, 10);
          this.$relatorios_analiticos.filterConsumidoresOmni.range_dates = [
            defaultDay,
            defaultDayCustom,
          ];
          break;
        }
      }
    },
    "$relatorios_analiticos.filterConsumidoresOmni.intervalo_datas_criacao"(e) {
      switch (e) {
        case "date": {
          const currentDay = new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
          // const day = new Date(new Date(currentDay).setDate(new Date(currentDay).getDate() + 1)).toISOString().slice(0, 10);
          this.$relatorios_analiticos.filterConsumidoresOmni.range_dates_create =
            [currentDay, currentDay];
          break;
        }
        case "week": {
          const currentDayWeek = this.dayjs().day(0).format("YYYY-MM-DD");
          const week = this.dayjs().day(6).format("YYYY-MM-DD");
          this.$relatorios_analiticos.filterConsumidoresOmni.range_dates_create =
            [currentDayWeek, week];
          break;
        }
        case "month": {
          const currentDayMonth = this.dayjs()
            .startOf("month")
            .format("YYYY-MM-DD");
          const month = this.dayjs().endOf("month").format("YYYY-MM-DD");
          this.$relatorios_analiticos.filterConsumidoresOmni.range_dates_create =
            [currentDayMonth, month];
          break;
        }
        case "custom": {
          const currentDayCustom = new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
          const custom = new Date(
            new Date(currentDayCustom).setDate(
              new Date(currentDayCustom).getDate() + 1
            )
          )
            .toISOString()
            .slice(0, 10);
          this.$relatorios_analiticos.filterConsumidoresOmni.range_dates_create =
            [currentDayCustom, custom];
          break;
        }
        default: {
          const defaultDay = new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
          const defaultDayCustom = new Date(
            new Date(defaultDay).setDate(new Date(defaultDay).getDate() + 1)
          )
            .toISOString()
            .slice(0, 10);
          this.$relatorios_analiticos.filterConsumidoresOmni.range_dates_create =
            [defaultDay, defaultDayCustom];
          break;
        }
      }
    },
    estado(state) {
      const { id, iso_full } = state;
      this.$relatorios_analiticos.filterConsumidoresOmni.estado = iso_full;

      const filteredId = this.$config.estados.result.find(
        item => item.dsc === state
      );

      this.$config.getCidades(id || filteredId.id);
    },
    menu(val) {
      val &&
        setTimeout(() => {
          if (
            val &&
            this.$relatorios_analiticos.filterConsumidoresOmni
              .intervalo_datas == "date"
          ) {
            this.activePicker = "DATE";
          } else if (
            val &&
            this.$relatorios_analiticos.filterConsumidoresOmni
              .intervalo_datas == "week"
          ) {
            this.activePicker = "DATE";
          } else if (
            val &&
            this.$relatorios_analiticos.filterConsumidoresOmni
              .intervalo_datas == "month"
          ) {
            this.activePicker = "MONTH";
          } else if (
            val &&
            this.$relatorios_analiticos.filterConsumidoresOmni
              .intervalo_datas == "custom"
          ) {
            this.activePicker = "DATE";
          } else {
            this.activePicker = "DATE";
          }
        });
    },
    menuCreate(val) {
      val &&
        setTimeout(() => {
          if (
            val &&
            this.$relatorios_analiticos.filterConsumidoresOmni
              .intervalo_datas_criacao == "date"
          ) {
            this.activePicker = "DATE";
          } else if (
            val &&
            this.$relatorios_analiticos.filterConsumidoresOmni
              .intervalo_datas_criacao == "week"
          ) {
            this.activePicker = "DATE";
          } else if (
            val &&
            this.$relatorios_analiticos.filterConsumidoresOmni
              .intervalo_datas_criacao == "month"
          ) {
            this.activePicker = "MONTH";
          } else if (
            val &&
            this.$relatorios_analiticos.filterConsumidoresOmni
              .intervalo_datas_criacao == "custom"
          ) {
            this.activePicker = "DATE";
          } else {
            this.activePicker = "DATE";
          }
        });
    },
    dateRangeText(e) {
      if (e) {
        this.$relatorios_analiticos.filterConsumidoresOmni.error.range_dates =
          [];
      }
    },
    dateRangeTextCreate(e) {
      if (e) {
        this.$relatorios_analiticos.filterConsumidoresOmni.error.range_dates_create =
          [];
      }
    },
  },
  methods: {
    monthEvent(month) {
      const currentDayMonth = this.dayjs(month)
        .startOf("month")
        .format("YYYY-MM-DD");
      const monthEnd = this.dayjs(month).endOf("month").format("YYYY-MM-DD");
      this.$relatorios_analiticos.filterConsumidoresOmni.range_dates = [
        currentDayMonth,
        monthEnd,
      ];
    },
    monthCreateEvent(month) {
      const currentDayMonth = this.dayjs(month)
        .startOf("month")
        .format("YYYY-MM-DD");
      const monthEnd = this.dayjs(month).endOf("month").format("YYYY-MM-DD");
      this.$relatorios_analiticos.filterConsumidoresOmni.range_dates_create = [
        currentDayMonth,
        monthEnd,
      ];
    },
    //   searchLoja(array, search) {
    //     let pesquisa = this.replaceSpecialChars(
    //       search.toString().toLocaleLowerCase().normalize("NFD")
    //     );
    //     let palavra = this.replaceSpecialChars(
    //       array.nome_loja.toString().toLocaleLowerCase().normalize("NFD")
    //     );
    //     if (palavra.indexOf(pesquisa) != -1) {
    //       return array;
    //     }
    // },
    // monthEvent(month) {
    //   const currentDayMonth = this.dayjs(month)
    //     .startOf("month")
    //     .format("YYYY-MM-DD");
    //   const monthEnd = this.dayjs(month).endOf("month").format("YYYY-MM-DD");
    //   this.$relatorios_analiticos.filterFinanceiroOmni.range_dates = [
    //     currentDayMonth,
    //     monthEnd,
    //   ];
    // },
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      // o resto
      return str.replace(/[^a-z0-9]/gi, "");
    },
    search(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.descricao.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
  },

  computed: {
    computeRange: {
      get() {
        return this.$relatorios_analiticos.filterConsumidoresOmni.range_dates;
      },
      set([firstDay]) {
        switch (
          this.$relatorios_analiticos.filterConsumidoresOmni.intervalo_datas
        ) {
          case "date":
            // const day = new Date(new Date(firstDay).setDate(new Date(firstDay).getDate() + 1)).toISOString().slice(0, 10);
            this.$relatorios_analiticos.filterConsumidoresOmni.range_dates = [
              firstDay,
              firstDay,
            ];
            break;
          case "week": {
            const currentDayWeek = this.dayjs(firstDay)
              .day(0)
              .format("YYYY-MM-DD");
            const week = this.dayjs(firstDay).day(6).format("YYYY-MM-DD");
            this.$relatorios_analiticos.filterConsumidoresOmni.range_dates = [
              currentDayWeek,
              week,
            ];
            break;
          }
          case "month": {
            const currentDayMonth = this.dayjs(firstDay)
              .startOf("month")
              .format("YYYY-MM-DD");
            const month = this.dayjs(firstDay)
              .endOf("month")
              .format("YYYY-MM-DD");
            this.$relatorios_analiticos.filterConsumidoresOmni.range_dates = [
              currentDayMonth,
              month,
            ];
            break;
          }
          case "custom": {
            const currentDayCustom = new Date(
              Date.now() - new Date().getTimezoneOffset() * 60000
            )
              .toISOString()
              .substr(0, 10);
            const custom = "";
            this.$relatorios_analiticos.filterConsumidoresOmni.range_dates = [
              currentDayCustom,
              custom,
            ];
            break;
          }
          default: {
            const defaultDay = "";
            this.$relatorios_analiticos.filterConsumidoresOmni.range_dates = [
              firstDay,
              defaultDay,
            ];
            break;
          }
        }
      },
    },
    computeRangeCreate: {
      get() {
        return this.$relatorios_analiticos.filterConsumidoresOmni
          .range_dates_create;
      },
      set([firstDay]) {
        switch (
          this.$relatorios_analiticos.filterConsumidoresOmni
            .intervalo_datas_criacao
        ) {
          case "date":
            // const day = new Date(new Date(firstDay).setDate(new Date(firstDay).getDate() + 1)).toISOString().slice(0, 10);
            this.$relatorios_analiticos.filterConsumidoresOmni.range_dates_create =
              [firstDay, firstDay];
            break;
          case "week": {
            const currentDayWeek = this.dayjs(firstDay)
              .day(0)
              .format("YYYY-MM-DD");
            const week = this.dayjs(firstDay).day(6).format("YYYY-MM-DD");
            this.$relatorios_analiticos.filterConsumidoresOmni.range_dates_create =
              [currentDayWeek, week];
            break;
          }
          case "month": {
            const currentDayMonth = this.dayjs(firstDay)
              .startOf("month")
              .format("YYYY-MM-DD");
            const month = this.dayjs(firstDay)
              .endOf("month")
              .format("YYYY-MM-DD");
            this.$relatorios_analiticos.filterConsumidoresOmni.range_dates_create =
              [currentDayMonth, month];
            break;
          }
          case "custom": {
            const currentDayCustom = new Date(
              Date.now() - new Date().getTimezoneOffset() * 60000
            )
              .toISOString()
              .substr(0, 10);
            const custom = "";
            this.$relatorios_analiticos.filterConsumidoresOmni.range_dates_create =
              [currentDayCustom, custom];
            break;
          }
          default: {
            const defaultDay = "";
            this.$relatorios_analiticos.filterConsumidoresOmni.range_dates_create =
              [firstDay, defaultDay];
            break;
          }
        }
      },
    },
    dateRangeText() {
      let arrayDates = [];
      this.$relatorios_analiticos.filterConsumidoresOmni.range_dates.forEach(
        item => {
          return arrayDates.push(this.$config.convertDataBR(item));
        }
      );

      return arrayDates.join(" ~ ");
    },
    dateRangeTextCreate() {
      let arrayDates = [];
      this.$relatorios_analiticos.filterConsumidoresOmni.range_dates_create.forEach(
        item => {
          return arrayDates.push(this.$config.convertDataBR(item));
        }
      );

      return arrayDates.join(" ~ ");
    },
    isAdmin() {
      if (this.$axios.getLocal("oe_user_info").data.user_type === "admin")
        return true;
      return false;
    },
  },
  beforeMount() {
    this.$axios.setLocal("person_type", "LOJA");
  },
  mounted() {
    this.$config.getEstados("9e1bf96ca2754ee6596f26fd6e6b5cc2");
  },
  destroyed() {
    this.$relatorios_analiticos.limpaFiltrosConsumidoresOmni();
  },
};
</script>
<style scoped></style>
